export default {
  api: {
    address: {
      type: {
        notNull: "Selecteer het type adres",
        found: "Het type adres bestaat al",
      },
    },
  },
}
